import { Component, Input } from '@angular/core';
import { Location } from '@angular/common';
import { Utils } from '../utils/utils';

@Component({
  selector: 'app-card-error',
  templateUrl: './card-error.component.html',
  styleUrls: ['./card-error.component.css']
})
export class CardErrorComponent {

  @Input() errorMessage?: string | null;
  @Input() showsRetryButton: boolean = true;

  constructor(private location: Location) { }
  
  reloadPage() {
    const currentUrl = this.location.path();
    const pathComponents = currentUrl.split('/');
    var finalUrl = '/';
    if(pathComponents.length > 1 && Utils.cardIdRegex.test(pathComponents[1])) {
      finalUrl = '/' + pathComponents[1];
    }
    
    const link = document.createElement('a');
    link.href = finalUrl;
    link.click();
  }
}
